
import { supabase } from '@/integrations/supabase/client';
import { Message } from '@/components/ai/types';

export interface OrchestratorRequest {
  content: string;
  contextData?: any;
  targetAgent?: string;
}

export interface OrchestratorResponse {
  content: string;
  metadata?: {
    status: string;
    targetAgent?: string;
    error?: string;
  };
}

export const sendMessageToOrchestrator = async (
  request: OrchestratorRequest
): Promise<Message> => {
  try {
    console.log('Sending message to orchestrator agent:', request);
    
    const { data, error } = await supabase.functions.invoke('orchestrator-agent', {
      body: {
        metadata: {
          targetAgent: request.targetAgent || 'executive-agent',
          subIntent: request.content,
          eventData: request.contextData,
          priority: 'normal'
        }
      }
    });

    if (error) {
      console.error('Orchestrator agent error:', error);
      throw new Error(error.message || 'Failed to communicate with orchestrator agent');
    }

    if (!data || !data.content) {
      console.error('Invalid response from orchestrator agent:', data);
      throw new Error('Invalid response from orchestrator agent');
    }

    console.log('Orchestrator agent response:', data);

    return {
      id: Date.now().toString(),
      content: data.content,
      sender: 'ai',
      timestamp: new Date()
    };

  } catch (error) {
    console.error('Error in sendMessageToOrchestrator:', error);
    
    // Return a fallback message instead of throwing
    return {
      id: Date.now().toString(),
      content: "I'm sorry, I'm having trouble connecting to the AI agent right now. Please try again in a moment.",
      sender: 'ai',
      timestamp: new Date()
    };
  }
};
